import React,{ useState, useEffect } from 'react';
import {
    Button,
    Collapse
} from 'antd';

import {
    GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3';

import {
    PhoneOutlined,
    MessageOutlined,
    RightOutlined,
    CaretRightOutlined
} from '@ant-design/icons';

import PublicRelationsMenu from './PublicRelationsMenu';
import SponsorshipMenu from './SponsorshipMenu';

function CompanyMenu() {

    const panelStyle = {
        marginBottom: 24,
        background: '#f8f8f8',
        borderRadius: '10px',
        border: 'none',
    };

    const getItems = (panelStyle) => [
        {
            key: '1',
            label: <>
                <h4>Public Relations</h4>
                <p>Get in touch for media inquiries and PR-related matters.</p>
            </>,
            children: <GoogleReCaptchaProvider reCaptchaKey="6LdmP8QkAAAAACX1XkPWEZ08HGoIkk1nClZiagMJ"><PublicRelationsMenu /></GoogleReCaptchaProvider>,
            style: panelStyle,
        },
        {
            key: '2',
            label: <>
                <h4>Sponsorship Inquires</h4>
                <p>Interested in sponsorship opportunities? Let's chat!</p>
            </>,
            children: <GoogleReCaptchaProvider reCaptchaKey="6LdmP8QkAAAAACX1XkPWEZ08HGoIkk1nClZiagMJ"><SponsorshipMenu /></GoogleReCaptchaProvider>,
            style: panelStyle,
        },
        {
            key: '3',
            label: <>
                <h4>Law Enforcement</h4>
                <p>This form is exclusive to law enforcement organizations. Please choose another option for general inquiries.</p>
            </>,
            children: <p>For law enforcement organizations making exigent requests,
            please notify us by calling <a href="tel:1-519-488-2099" >1-519-488-2099</a>.</p>,
            style: panelStyle,
        },
    ];

    return (
        <div className='company-menu-items'>
            <Collapse
                bordered={false}
                //defaultActiveKey={['1']}
                expandIcon={
                    ({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />
                }
                items={getItems(panelStyle)}
            />
        </div>
    )
}

export default CompanyMenu